const ON_CHANGE_DEBOUNCE_TIMER = 300;

/**
 * Shared fetch options for cart / product AJAX requests.
 * Defined here (loads before global.js and cart.js) so cart actions never depend on global.js finishing.
 */
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

window.fetchConfig = fetchConfig;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  cartRemove: 'cart-remove',
  cartQtyUpdate: 'cart-quantity-update',
  submitButtonChange: 'submit-button-change',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  sizeSelectedOptionClick: 'size-checked-click',
  swatchChange: 'swatch-change',
};
